export default __webpack_public_path__ + "static/media/swords.843677b7.png";